export default __webpack_public_path__ + "static/media/LogoIcon.881de963.svg";